import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { ECOSYSTEM_NOTE } from '@/data/ecosystem';
import { Reveal } from '../Reveal';

export const PurchasingNote = () => (
  <section aria-label="How purchasing works" data-testid="ecosystem-note" className="bg-white py-16 sm:py-20">
    <div className="mx-auto max-w-4xl px-4 sm:px-6">
      <Reveal>
        <div className="rounded-2xl border border-slate-200 bg-mist p-8 sm:p-10">
          <p className="flex items-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest text-gold-700">02</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">{ECOSYSTEM_NOTE.heading}</span>
          </p>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">{ECOSYSTEM_NOTE.text}</p>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2">
            {[
              'Fixed-scope services will be available to buy or book directly once pricing is confirmed',
              'Bespoke work always starts with a conversation and a clear scope',
              'No payment is taken online yet — every action today is an enquiry or details view',
            ].map((point) => (
              <li key={point} className="flex items-start gap-2.5 text-sm font-medium text-navy-800">
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-gold-700" aria-hidden="true" />
                {point}
              </li>
            ))}
          </ul>
          <Link
            to="/?source=Ecosystem#solution-finder"
            data-testid="ecosystem-note-link"
            className="group mt-7 inline-flex items-center gap-2 text-sm font-bold text-navy-900 transition-colors hover:text-gold-700"
          >
            Tell us what you need
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
